import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dc612bb8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "server-list" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "交付服务", -1))
const _hoisted_3 = ["src"]

import { onMounted, ref } from 'vue'
import { useStore } from 'vuex'

import AppHeader from '@/components/Header.vue'
import appHost from '@/utils/app'
import IconArrowRight from '@/assets/icon-arrow-right.svg'
import { usePlatformInfo } from '@/compositions/common'
import { useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'delivery-service',
  setup(__props) {

const { judgeIsSrc4Device } = usePlatformInfo()

const isSrc4 = ref(true)
const Router = useRouter()
const onLeftClick = function () {
  appHost.goAppBack()
}

const gotoListHanlder = () => {
  Router.push({
    name: 'delivery-service-list',
  })
}

onMounted(async () => {
  try {
    isSrc4.value = await judgeIsSrc4Device()
  } catch (error) {
    console.log('error', error)
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, {
      title: "更多",
      onLeftClick: onLeftClick,
      isReturnLeftEvent: ""
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "server-item",
        onClick: gotoListHanlder
      }, [
        _hoisted_2,
        _createElementVNode("img", {
          width: "16",
          height: "16",
          src: _unref(IconArrowRight)
        }, null, 8, _hoisted_3)
      ])
    ])
  ], 64))
}
}

})